import { render, staticRenderFns } from "./BauComplementAssessmentStep.vue?vue&type=template&id=79a63e94"
import script from "./BauComplementAssessmentStep.vue?vue&type=script&lang=js"
export * from "./BauComplementAssessmentStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports